import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function FlipCard({ label, count, imgSrc, filter }) {
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const mobile = window.matchMedia("(pointer: coarse)").matches;
    setIsMobile(mobile);
  }, []);

  const handleClick = () => {
    navigate("/all-hiring-request", { state: { filter: filter || "all" } });
  };

  return (
    <div
      onClick={handleClick}
      className="cursor-pointer relative transition-all duration-300 hover:scale-[1.02] active:scale-[0.98] group  "
      title="Go to Hiring Requests"
    >
      <div 
        className="w-full p-6 flex flex-row items-center rounded-2xl gap-8 h-full relative overflow-hidden"
        style={{
          backgroundColor: '#fff',
          boxShadow: '0 10px 30px rgba(18, 76, 114, 0.12)',
          border: '1px solid rgba(18, 76, 114, 0.1)'
        }}
      >
        {/* Gradient accent */}
        <div 
          className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
          style={{
            background: 'linear-gradient(135deg, rgba(18, 76, 114, 0.05), rgba(18, 76, 114, 0.02))'
          }}
        />
        
        {/* Left border accent */}
        <div 
          className="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-16 rounded-r-full opacity-0 group-hover:opacity-100 transition-opacity duration-500"
          style={{
            backgroundColor: 'rgb(18, 76, 114)',
            background: 'linear-gradient(to bottom, rgb(18, 76, 114), rgba(18, 76, 114, 0.8))'
          }}
        />

        <div 
          className="p-3 rounded-xl relative z-10"
          style={{ 
            backgroundColor: 'rgba(18, 76, 114, 0.1)',
            border: '1px solid rgba(18, 76, 114, 0.15)'
          }}
        >
          <img 
            src={imgSrc} 
            alt={label} 
            className="h-[42px] w-[42px] object-contain"
            style={{ filter: 'brightness(0) saturate(100%) invert(14%) sepia(40%) saturate(600%) hue-rotate(170deg) brightness(90%) contrast(90%)' }}
          />
        </div>

        <div className="relative z-10">
          <label 
            className="font-semibold text-[18px] block mb-1 transition-colors duration-300 group-hover:opacity-90"
            style={{ color: 'rgba(18, 76, 114, 0.8)' }}
          >
            {label}
          </label>
          <p 
            className="text-[32px] font-bold transition-all duration-300 group-hover:scale-105"
            style={{ color: 'rgb(18, 76, 114)' }}
          >
            {count}
          </p>
          
          {/* Subtle click hint */}
          <div className="flex items-center gap-1 mt-2 opacity-0 group-hover:opacity-70 transition-opacity duration-300">
            <span 
              className="text-xs font-medium"
              style={{ color: 'rgba(18, 76, 114, 0.6)' }}
            >
              View details
            </span>
            <svg 
              className="w-3 h-3" 
              style={{ color: 'rgba(18, 76, 114, 0.6)' }}
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
            </svg>
          </div>
        </div>

        {/* Hover effect indicator */}
        <div 
          className="absolute right-6 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-all duration-300"
          style={{ color: 'rgba(18, 76, 114, 0.5)' }}
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
          </svg>
        </div>
      </div>

      {/* Active state overlay */}
      <div 
        className="absolute inset-0 rounded-2xl opacity-0 active:opacity-20 pointer-events-none transition-opacity duration-150"
        style={{ backgroundColor: 'rgb(18, 76, 114)' }}
      />
    </div>
  );
}